module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "ch5"
    }
  }, [_vm._v("SPRAWL")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Melons sprawl from root.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("In Pin riverlands, earth")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("gave birth to our people.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Our true old father T’ai")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("made us shelters, kiln-huts,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("for houses were unknown.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Then T’ai our true father")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("went early on his horse,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("following the Wei River")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("west to Bowhand Mountain,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("found Lady Shepherdess")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("and with her shared roof.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Chou plains rich and full,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("thistle-weed and bitterroot")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("like honey-cake, he began")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("planning. Tortoise shells")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("said: "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("This place. This time.")])]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("And soon houses were built.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He comforted and he settled")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("his people on every side,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("laid out bounds and borders,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("shaped fields, sent farmers")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("east and west, everywhere")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("fashioning his project well.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He called master builders,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("master teachers, bade them")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("build houses, plumb-lines")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("taut and true, bade them")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("lash timbers into that regal")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("temple ancestors would love.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("We hauled earth in baskets,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("crowds swarming, measuring,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("packing it hard "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("hunk, hunk,")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("scraping it clean "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("ping, ping:")])]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("a hundred walls built so fast")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("no work-drum could keep up.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Soon outer gates stood firm,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("outer gates looming up, lofty,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("then inner gates stood firm,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("inner gates regal and strong.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And soon the Earth Altar too,")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("where all our endeavors begin.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("True T’ai—his righteous anger never faded,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and he never let his great renown falter.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("He cleared oak and thorn-oak")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and opened roads far and wide.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And the mud-faced tribes, they")]), _vm._v(" "), _c('p', {
    staticClass: "vsb"
  }, [_vm._v("fled in broken-winded panic.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Our neighbors in Yü and Jui pledged peace:")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("Emperor Wen always kindled native nobility.")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("And so we call him sovereign near and far,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("sovereign we call him over before and after,")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("sovereign too over those who flee or return")]), _vm._v(" "), _c('p', {
    staticClass: "v"
  }, [_vm._v("and even over those who ridicule and resist.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eef91ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 87
// module chunks = 0